import React from 'react';
import Card from '~/components/shared/Card/Card';
import CardHeader from '~/components/shared/CardHeader/CardHeader';
import {
  FontWeights,
  Typography,
} from '~/components/shared/Typography/Typography';
import useTranslate from '~/hooks/useTranslate';
import { TerminatedContract } from '~/Interfaces';
import CardSection from '~/components/shared/CardSection/CardSection';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getQredOrg, ReschedulingFees } from '~/constants/markets';
import { RootState } from '~/store/types/sharedTypes';
import { formatAmount, formatDate } from '~/helpers/formatters.helper';

interface TerminatedContractCardProps {
  terminatedContract: TerminatedContract;
}

const OptionsText = styled.div`
  margin: 1em 0;
`;

const MarginTopSection = styled.div`
  margin-top: 1em;
`;

const TerminatedContractCard = (props: TerminatedContractCardProps) => {
  const { market, language } = useSelector((state: RootState) => state.intl);
  const t = useTranslate();
  return (
    <Card>
      <CardSection>
        <CardHeader value={t('TerminationCredit') as string} noPadding />
        <Typography lineHeight={1.4}>
          {`${t('TerminatedContractComponent.Reminders')} ${formatDate(
            props.terminatedContract.terminatedDate,
            language
          )}.`}
        </Typography>
        <MarginTopSection>
          <Typography fontWeight={FontWeights.Thick} lineHeight={1.4}>
            {t('TerminatedContractComponent.Options')}
          </Typography>
        </MarginTopSection>
        <OptionsText>
          <Typography lineHeight={1.4}>
            {t('TerminatedContractComponent.OptionPaybackCredit')}
          </Typography>
        </OptionsText>
        <Typography lineHeight={1.4}>
          {`
          ${t('TerminatedContractComponent.PaybackDebtOf')}
          ${props.terminatedContract.earlyRepaymentAmount}
          ${t('TerminatedContractComponent.PaybackRest')}
          `}
        </Typography>
        <OptionsText>
          <Typography lineHeight={1.4}>
            {t('TerminatedContractComponent.OptionKeepCredit')}
          </Typography>
        </OptionsText>
        <Typography lineHeight={1.4}>
          {t('TerminatedContractComponent.KeepCreditPayment', {
            fee: ReschedulingFees[market],
            minimumFee: formatAmount(
              Number(props.terminatedContract.amountToPay)
            ),
          })}
        </Typography>
        <Typography lineHeight={1.4}>
          {t('TerminatedContractComponent.AvoidCollection', {
            granterBank: props.terminatedContract.granterBank,
            ocr: props.terminatedContract.ocr,
            date: formatDate(props.terminatedContract.terminatedDate, language),
          })}
        </Typography>
        <Typography lineHeight={1.4}>
          {t('TerminatedContractComponent.Collection')}
        </Typography>
        <MarginTopSection>
          <Typography lineHeight={1.4}>
            {getQredOrg(market, language)}
          </Typography>
        </MarginTopSection>
      </CardSection>
    </Card>
  );
};

export default TerminatedContractCard;
